import { useNavigate } from "react-router";

export function useNavigateToRessource<T>(
  routeTemplate: string,
  idAccessor: (response: T) => string | number
): (response: T) => void {
  const navigate = useNavigate();

  const navigateToRessource = (response: T) => {
    const idValue = idAccessor(response);
    const route = routeTemplate.replace("{{id}}", String(idValue));

    navigate(route);
  };

  return navigateToRessource;
}
